export default __webpack_public_path__ + "static/media/space.36630187.jpg";